var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveAs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41309 15H4.66309H4.16309C2.50623 15 1.16309 13.6569 1.16309 12V4C1.16309 2.34315 2.50623 1 4.16309 1H8.16309H9.72045C10.5161 1 11.2792 1.31607 11.8418 1.87868L14.6681 4.70503C14.985 5.02195 15.1631 5.4518 15.1631 5.9V5.9",
    stroke: "#7D899D",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16309 15V11C4.16309 9.89543 5.05852 9 6.16309 9V9H7.16309H8.16309",
    stroke: "#7D899D",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36304 1V3.5C5.36304 4.05228 5.81075 4.5 6.36304 4.5H9.96304C10.5153 4.5 10.963 4.05228 10.963 3.5V1",
    stroke: "#7D899D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2022 8.57301L10.6622 12.113C10.5222 12.253 10.3922 12.513 10.3622 12.703L10.1722 14.053C10.1022 14.543 10.4422 14.883 10.9322 14.813L12.2822 14.623C12.4722 14.593 12.7422 14.463 12.8722 14.323L16.4122 10.783C17.0222 10.173 17.3122 9.46303 16.4122 8.56303C15.5222 7.67303 14.8122 7.96301 14.2022 8.57301Z",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6904 9.08301C13.9904 10.163 14.8304 11.003 15.9104 11.303",
    stroke: "#7D899D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveAs);
export default __webpack_public_path__ + "static/media/save-as.9268c635.svg";
export { ForwardRef as ReactComponent };